import { Autocomplete, TextField } from '@mui/material'
import React from 'react'
import { MapContext } from '../../../context/MapContext'
import { useCity } from '../../../context/CityContext'
import styles from './AddAddress.module.css'
import {Point} from '../../../__generated__/types';
import {useAddressSuggestionsQuery} from '../Address/__generated__/Address';
import { formatAddress } from '../../../utils/formatAddress';

export const AddAddress = ({ point }: { point: Point | null }) => {
    const { addPointByAddress } =
        React.useContext(MapContext)
    const { selectedCity } = useCity()
    const [open, setOpen] = React.useState(false)
    const [options, setOptions] = React.useState<readonly Point[]>([])
    const [loading, setLoading] = React.useState<boolean>(false)

    const { refetch } = useAddressSuggestionsQuery({
        fetchPolicy: 'standby',
        variables: {
            input: null!,
            cityId: null
        }
    })

    return (
        <div className={styles.addAddress}>
            <div style={{ display: 'flex' }}>
                <Autocomplete
                    style={{ width: '90%' }}
                    id='standard-basic'
                    open={open}
                    value={point}
                    onInputChange={(_, value, reason) => {
                        if (reason === 'input' && value.length > 3) {
                            setOpen(true)
                            setLoading(true)
                            refetch({
                                input: value,
                                cityId: selectedCity?.id ?? null
                            })
                                .then((res) => {
                                    setOptions(res.data?.searchAddress ?? [])
                                    setLoading(false)
                                })
                                .catch(() => setLoading(false))
                        }
                    }}
                    onClose={() => {
                        setOpen(false)
                    }}
                    onChange={(_, value) => {
                        value && addPointByAddress(value)
                    }}
                    getOptionLabel={(option) =>
                        formatAddress(option, {
                            cityId: selectedCity?.id ?? null,
                            countryName: selectedCity?.countryName ?? null
                        })
                    }
                    options={options}
                    loading={loading}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant='standard'
                            placeholder='Добавить остановку'
                            multiline
                            minRows={1}
                            maxRows={2}
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                style: {
                                    fontSize: '16px',
                                    lineHeight: '1',
                                    paddingRight: '0'
                                },
                                endAdornment: null
                            }}
                        />
                    )}
                />
            </div>
        </div>
    )
}
